module.exports = __webpack_public_path__ + "static/media/Politica_de_privacidad.74e8ac04.pdf";